import React from 'react';
import { ConfigContext } from '../context/configContext';

/**
 * Represents the tenant configuration higher-order component.
 * @param {Any} Component The component to enhance.
 * @remarks Use this HOC to access the current tenant's config.
 */
const withConfig = (Component) => {
  const closure = props => (
    <ConfigContext.Consumer>
      {
        config => (
          <Component
            config={config}
            {...props} />
        )
      }
    </ConfigContext.Consumer>
  );

  return closure;
};

export default withConfig;
